import React, { useState } from "react";
import { connect } from "react-redux";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { login } from "../../store/thunks";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import { InputError } from "../common/InputError";
import { useForm } from "react-hook-form";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";
import { post } from "../../api";
import { setLoginDataDetail } from "../../store/thunk/user";

const LoginAccount = ({ email, setLoginDataDetail }) => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState(email || "");
  const [isForgotPasswordLoading, setForgotPasswordLoading] = useState(false);

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({});

  const goTo = (link) => {
    navigate(link);
  };

  const handleAccountSubmit = async (data) => {
    const payload = {...data, email};
    setLoading(true);
    try {
      const url = "/api/auth/login";
      const res = await post(url, payload);
      if (res?.status == 200) {
        toast.success("Logged in successfully.");
        setLoginDataDetail(res?.data)
        goTo('/dashboard');
      } else {
        toast.error("Invalid credentials or your account has been archived. Please try again with valid email id.")
      }
    } catch(e) {
      toast.error("Invalid credentials or your account has been archived. Please try again with valid email id.")
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    if (!forgotPasswordEmail) {
      toast.error("Please enter your email address");
      return;
    }

    setForgotPasswordLoading(true);
    try {
      const res = await post("/api/auth/forgot-password", { email: forgotPasswordEmail });
      if (res?.status === 200) {
        toast.success("Password reset link sent to your email");
        setForgotPasswordOpen(false);
      } else {
        toast.error("Failed to send reset link. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again later.");
    } finally {
      setForgotPasswordLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-md-12 right-panel bg-white">
        <form onSubmit={handleSubmit(handleAccountSubmit)}>
          <h2 className="mb-2">Welcome</h2>
          <p>
            <strong>Welcome Back!</strong><br/>
            <small>
              It looks like you already have an account with us, we just need
              your password and we can log you in.
            </small>
          </p>
          <hr />
          <div className="form-group mt-2 mb-2">
            <label htmlFor="email">Password</label>
            <input
              type="password"
              className="form-control"
              id="password"
              placeholder="Your password"
              {...register("password", {
                required: {
                  value: true,
                  message: `Please enter your password.`,
                },
              })}
            />
            {errors?.password && (
              <InputError
                message={errors?.password?.message}
                key={errors?.password?.message}
              />
            )}
          </div>
          <div className="text-end mb-3">
            <button 
              type="button" 
              className="btn btn-link p-0"
              onClick={() => setForgotPasswordOpen(true)}
            >
              Forgot Password?
            </button>
          </div>
          {isLoading && (
            <Box sx={{ display: "flex" }}>
              <CircularProgress />
            </Box>
          )}
          {!isLoading && (
            <div className="form-group mt-4">
              <button
                type="submit"
                className="btn btn-primary rounded w-100 login-submit"
              >
                Login
              </button>
            </div>
          )}
        </form>

        {/* Forgot Password Dialog */}
        <Dialog open={forgotPasswordOpen} onClose={() => setForgotPasswordOpen(false)}>
          <DialogTitle>Forgot Password</DialogTitle>
          <DialogContent>
            <p>Enter your email address to receive a password reset link.</p>
            <TextField
              autoFocus
              margin="dense"
              id="forgot-email"
              label="Email Address"
              type="email"
              fullWidth
              variant="standard"
              value={forgotPasswordEmail}
              onChange={(e) => setForgotPasswordEmail(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setForgotPasswordOpen(false)}>Cancel</Button>
            <Button 
              onClick={handleForgotPassword}
              disabled={isForgotPasswordLoading}
            >
              {isForgotPasswordLoading ? (
                <CircularProgress size={24} />
              ) : (
                "Send Reset Link"
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default connect(null, { login, setLoginDataDetail })(LoginAccount);